import React from 'react'
import { Icon } from '@chakra-ui/react'

export function IconReporting(rest) {
  return (
    <Icon viewBox="0 0 32 32" {...rest}>
      <g transform="translate(4 3)">
        <g fillRule="evenodd" fill="currentColor" clipRule="evenodd">
          <path d="m5 21v-1h14v1zm0-4v-1h14v1zm0-4v-1h14v1zm0-4v-1h6v1z" />
        </g>
        <g
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1}
        >
          <path d="m.5.5v26h23v-18.29289322l-7.7071068-7.70710678z" />
          <path d="m16.5 1.20710678v6.29289322h6.2928932z" />
        </g>
      </g>
    </Icon>
  )
}
